import { render } from "./PreloaderMainComponent.vue?vue&type=template&id=7c2d4a52&scoped=true"
const script = {}

import "./PreloaderMainComponent.vue?vue&type=style&index=0&id=7c2d4a52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2d4a52"]])

export default __exports__